/**
 * Định nghĩa các cột fix cứng dùng chung trên chương trình
 */
export default {
  amountOc: 'amount_oc',
  amount: 'amount',
  debitAccount: 'debit_account',
  creditAccount: 'credit_account',
  budgetSourceId: 'budget_source_id',
  cashWithdrawTypeId: 'cash_withdraw_type_id',
  methodDistributeType: 'method_distribute_type',
  orgRefDetailId:'org_ref_detail_id', //Thông tin trường đánh dấu chứng từ detail gốc sinh ra dòng hạch toán
  refDetailId: 'ref_detail_id' //Thông tin trường là khóa chi tiết chứng từ map với orgRefDetailId ở trên
};
